import React from "react";
import { LoadingButton } from "@mui/lab";
import { ToggleOff, ToggleOn } from "@mui/icons-material";
import AppConfirmDialog from "./AppConfirmDialog";

export const EnableDisableButton = ({
  suffix = "",
  isActive = true,
  prefixArray = ["Enable", "Disable"],
  children,
  loading = false,
  onClick: primaryAction = () => {},
  ...buttonProps
}) => {
  const [showConfirm, setShowConfirm] = React.useState(false);

  const _prefix = !isActive ? prefixArray[0] : prefixArray[1];

  return (
    <>
      <LoadingButton
        variant="outlined"
        startIcon={isActive ? <ToggleOff /> : <ToggleOn />}
        color={isActive ? "error" : "success"}
        onClick={() => setShowConfirm(true)}
        {...{ ...buttonProps, loading }}
      >
        {_prefix} {children}
      </LoadingButton>

      <AppConfirmDialog
        maxWidth="sm"
        loading={loading}
        open={showConfirm}
        onClose={() => setShowConfirm(false)}
        onConfirm={ () => {
          primaryAction()
          setShowConfirm(false)
        }}

      >
        Are you sure you want to {_prefix?.toLowerCase()} this {suffix}?
      </AppConfirmDialog>
    </>
  );
};

export default EnableDisableButton;
